// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs-moduletabsbG1","tab":"Tabs-moduletab3qr","tabActive":"Tabs-moduletabActiveqoS"};